import styled from 'styled-components';

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none; /* evita bloquear interações na ul */
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ArrowZone = styled.div`
  width: 30px; /* área de detecção de hover */
  position: relative;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto; /* permite clique nas setas */
  border-radius: 50%;
  background-color: ${({ theme }) => theme.neutral[800]};
  box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 28px,
    rgba(0, 0, 0, 0.22) 0px 10px 10px;
  cursor: pointer;
  transition: 200ms;

  @media (max-width: 1630px) {
    opacity: 1;
  }

  @media (min-width: 1630px) {
    opacity: 0;
    &:hover {
      opacity: 1;
    }
  }
`;
